const videoControl = {};

videoControl.init = () => {

    // check on play buttons
    let buttons = document.querySelectorAll(".js-play-button");
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener("click", togglePlayButton, false);
    }
    function togglePlayButton(e) {
        let button = e.target;
        let video = button.parentElement.previousElementSibling;
        if (video.paused || video.ended) {
            video.play();
        } else {
            video.pause();
        }
        video.addEventListener("playing", function () {
            e.target.style.opacity = 0;
        });
        video.addEventListener("pause", function () {
            e.target.style.opacity = 1;
        });
    }

    // check on video if is playing
    let videos = document.querySelectorAll(".js-video");
    for (let i = 0; i < videos.length; i++) {
        videos[i].addEventListener("click", togglePlayVideo, false);
    }

    function togglePlayVideo(e) {
        let video = e.target;
        let button = video.nextElementSibling;
        video.addEventListener("playing", function () {
            button.style.opacity = 0;
        });
        video.addEventListener("pause", function () {
            button.style.opacity = 1;
        });
    }

}

export default videoControl;
